const getFetchItemOnMeliplusUpdate = (updateAction, getState) => {
  const { id, platform, app, filters: pdp_filters, vip_filters, attributes, components } = getState();
  const { available_quantity, bulk_sale_quantity } = components;
  const quantity = available_quantity?.picker?.selected ?? bulk_sale_quantity?.selected;
  return { id, platform, app, pdp_filters, vip_filters, attributes, quantity, updateAction };
};

export { getFetchItemOnMeliplusUpdate };
